module.exports = __webpack_public_path__ + "img/insta_10.684c0159.jpg";